/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import styled from 'styled-components';
import { Flex } from '@motili/ui';
import Config from 'Config';

export const RibbonItemContainer = styled(Flex).attrs(props => ({
    direction: 'row',
    align: 'center',
    gap: props.gap ?? '10px',
}))<{ clickable?: boolean }>`
    font-weight: 600;
    color: ${Config.color.darkCharcoal};
    ${({ clickable }) => {
        return clickable
            ? `
          cursor: pointer;
          max-width: 0;
          white-space: nowrap;
        `
            : '';
    }}
    & .expand-toggle:hover {
        background-color: #f0f0f0;
        border-radius: 50%;
    }
`;
